import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { RoleTaskSourceLink } from '../../services/api/roleWorkspaceService';

const triggerLabel = (value: string) => value.replace(/_/g, ' ');

export default function RoleTaskQueue({
  rows,
  onComplete,
  completingId,
}: {
  rows: RoleTaskSourceLink[];
  onComplete?: (taskId: string) => void;
  completingId?: string | null;
}) {
  if (!rows.length) {
    return <Alert severity="info">No open role tasks for this workspace.</Alert>;
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Task</TableCell>
          <TableCell>Trigger</TableCell>
          <TableCell>Source</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Next action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.id} hover>
            <TableCell>
              <Typography variant="body2" fontWeight={700}>{row.task.taskCode}</Typography>
              <Typography variant="caption" color="text.secondary">{row.task.name}</Typography>
            </TableCell>
            <TableCell>{triggerLabel(row.triggerType)}</TableCell>
            <TableCell>
              <Stack spacing={0.25}>
                <Typography variant="body2">{triggerLabel(row.sourceType)}</Typography>
                <Typography variant="caption" color="text.secondary">{row.sourceId}</Typography>
              </Stack>
            </TableCell>
            <TableCell><Chip size="small" label={row.task.lifecycleStatus.replace(/_/g, ' ')} /></TableCell>
            <TableCell>
              {onComplete && (
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => onComplete(row.task.id)}
                  disabled={completingId === row.task.id}
                >
                  {completingId === row.task.id ? 'Completing...' : 'Complete'}
                </Button>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
